// components/Navbar.jsx
import React, { useState } from "react";
import "./Navbar.css";
import MenuIcon from "@mui/icons-material/Menu";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import { useNavigate } from "react-router-dom";
import Logo from "../../../Home/Components/Logo/Logo";

function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMobile = () => setOpen((o) => !o);

  const navItems = [
    { label: "Home", target: "hero" },
    { label: "Features", target: "features" },
    { label: "Who its for", target: "who" },
    { label: "Community", target: "community" },
    { label: "Who We Are", target: "about" },
    { label: "Contact", target: "contact" },
  ];

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false); // close mobile menu
  };

  return (
    <header className="tawaf-navbar">
      <div className="tawaf-navbar-inner">
        <div className="tawaf-navbar-left">
          <div className="tawaf-logo" onClick={() => scrollToSection("hero")}>
            <Logo alwaysShowText={true} />
          </div>
        </div>

        {/* Desktop Nav */}
        <nav className="tawaf-nav-links">
          {navItems.map((item) => (
            <button
              key={item.label}
              className="tawaf-nav-link"
              onClick={() => scrollToSection(item.target)}
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Desktop Social Icons */}
        <div className="tawaf-nav-social">
          <a
            aria-label="Facebook"
            href="https://www.facebook.com/profile.php?id=61583006320861"
            target="_blank"
            rel="noreferrer"
          >
            <FacebookRoundedIcon fontSize="small" />
          </a>

          <a
            aria-label="Instagram"
            href="https://www.instagram.com/tawaf_ai/"
            target="_blank"
            rel="noreferrer"
          >
            <InstagramIcon fontSize="small" />
          </a>

          <a
            aria-label="X (Twitter)"
            href="https://x.com/Tawaf_AI"
            target="_blank"
            rel="noreferrer"
          >
            <TwitterIcon fontSize="small" />
          </a>
        </div>

        {/* Desktop Actions */}
        <div className="tawaf-nav-actions">
          <button
            className="tawaf-nav-ghost"
            onClick={() => navigate("/login")}
          >
            Log In
          </button>

          <button
            className="btn-primary tawaf-nav-cta"
            onClick={() => navigate("/signup")}
          >
            Join Now
          </button>
        </div>

        {/* Mobile Toggle */}
        <button className="tawaf-nav-mobile-toggle" onClick={toggleMobile}>
          {open ? <CloseRoundedIcon /> : <MenuIcon />}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="tawaf-nav-mobile-menu">
          {navItems.map((item) => (
            <button
              key={item.label}
              className="tawaf-nav-mobile-link"
              onClick={() => scrollToSection(item.target)}
            >
              {item.label}
            </button>
          ))}

          <div className="tawaf-nav-mobile-actions">
            <button
              className="tawaf-nav-ghost"
              onClick={() => {
                navigate("/login");
                setOpen(false);
              }}
            >
              Log In
            </button>

            <button
              className="btn-primary tawaf-nav-cta"
              onClick={() => {
                navigate("/signup");
                setOpen(false);
              }}
            >
              Join Now
            </button>
          </div>

          {/* Mobile Social Icons */}
          <div className="tawaf-nav-mobile-social">
            <a
              aria-label="Facebook"
              href="https://www.facebook.com/profile.php?id=61583006320861"
              target="_blank"
              rel="noreferrer"
            >
              <FacebookRoundedIcon fontSize="small" />
            </a>

            <a
              aria-label="Instagram"
              href="https://www.instagram.com/tawaf_ai/"
              target="_blank"
              rel="noreferrer"
            >
              <InstagramIcon fontSize="small" />
            </a>

            <a
              aria-label="X (Twitter)"
              href="https://x.com/Tawaf_AI"
              target="_blank"
              rel="noreferrer"
            >
              <TwitterIcon fontSize="small" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}

export default Navbar;
